/**
 * Key Ingredients block (mobile): no loop, start at second slide so first peeks on the left.
 */
function initKeyIngredientsSlider() {
  const block = document.querySelector('.product-info__key-ingredients');
  if (!block) return;
  if (block.dataset.sliderInited) return;
  block.dataset.sliderInited = '1';

  const slider = block.querySelector('[id^="Slider-"]');
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll('.slider__slide'));
  if (slides.length < 2) return;

  const firstSlide = slides[0];
  const secondSlide = slides[1];
  const peekFraction = 0.25;
  const left = secondSlide.offsetLeft - firstSlide.offsetWidth * peekFraction;

  function setInitialPosition() {
    block.classList.add('key-ingredients--jumping');
    slider.scrollLeft = Math.max(0, left);
    setTimeout(() => block.classList.remove('key-ingredients--jumping'), 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setInitialPosition);
  } else {
    setInitialPosition();
  }

  window.addEventListener('resize', () => {
    clearTimeout(window._keyIngredientsResize);
    window._keyIngredientsResize = setTimeout(setInitialPosition, 100);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKeyIngredientsSlider);
} else {
  initKeyIngredientsSlider();
}
